module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-chrome-permission-1-298a1a7ddd8207c981b36d901a5948d5.png";